<template>
    <!-- 运动员 -->
  <div class="sub-page">
    <div class="row title">
      <div class="col-1">序号</div>
      <div class="col-2">代表队</div>
      <div class="col-3">运动员</div>
      <div class="col-4">参赛项目</div>
      <div class="col-5">性别</div>
      <div class="col-6">出生年月</div>
    </div>
    <div class="row" @click="paylerDetail">
      <div class="col-1">1</div>
      <div class="col-2">参赛代表队</div>
      <div class="col-3">
        <img src="../../../../assets/avatar.jpg" alt="">
        <span>运动员姓名</span>
      </div>
      <div class="col-4">110米跨栏 丨 4X100米接力</div>
      <div class="col-5">男</div>
      <div class="col-6">1990.02.34</div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
    },
    data() {
        return {
         
        }
    },
    mounted () {
    },
    methods: {
        paylerDetail() {
            this.$router.push({name:"TrackFieldPlayer"})
        }
    },
}
</script>

<style lang="scss" scoped>
.sub-page{
  width: 100%;
  margin-bottom: 30px;
  .row{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 70px;
    line-height: 70px;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    font-size: 14px;
    border-bottom: 1px solid #E1E1E1;
    cursor: pointer;
    .col-1{
      width: 10%;
    }
    .col-2{
      width: 25%;
    }
    .col-3{
      width: 25%;
      img{
        width: 40px;
        height: 40px;
        border-radius: 20px;
        margin-right: 10px;
      }
    }
    .col-4{
      width: 20%;
    }
    .col-5{
      width: 5%;
      text-align: center;
    }
    .col-6{
      width: 10%;
      text-align: center;
    }
  }
  .title{
    font-size: 16px;
    color: #000000;
  }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/match/trackfield/components/TrackfieldAthlete.vue